<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{cvCardTitle}}</h4>
          </template>
          <template v-slot:body>
            <form action="#" v-if="vmAdminEmailTempFormData && Object.keys(vmAdminEmailTempFormData).length > 0">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationemail_body"> {{cvDomainName}}</label><br>
                  <input
                    v-model="vmAdminEmailTempFormData.app_email_domain"
                    type="text"
                    class="form-control"
                    placeholder="E.g: web.gide.ai"
                    required
                  />
                  <span class="information-color"><small>Ex: www.clatperfect.com, web.gide.ai</small></span>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationemail_body">{{cvEmailTemplateIdLabel}}</label>
                  <input
                    v-model="vmAdminEmailTempFormData.email_template_id"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationemail_body"> {{cvEmailTemplateNameLabel}}</label>
                  <input
                      v-model="vmAdminEmailTempFormData.email_template_name"
                      type="text"
                      class="form-control"
                      required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationmodule_name">{{cvModuleNameLabel}}&nbsp;&nbsp;<small>(Event, Testprep, Sat Etc)</small></label>
                  <input
                    v-model="vmAdminEmailTempFormData.module_name"
                    type="text"
                    class="form-control"
                    required
                  />
                  <small class="information-color">Ex: &nbsp;EVENT, TESTSERIES, GPATH, etc</small>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationmodule_object_id">{{cvModuleObjectIdLabel}}</label>
                  <input
                    v-model="vmAdminEmailTempFormData.module_object_id"
                    type="text"
                    class="form-control"
                    required
                  />
                  <small class="information-color">Ex: &nbsp;eve1234abcd, app123456, gpathxxx7777, etc</small>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationaction">{{cvAIActions}}</label>
                  <input
                    v-model="vmAdminEmailTempFormData.action"
                    type="text"
                    class="form-control"
                    required
                  />
                  <small class="information-color">Ex:Steps to take GPath Assessment, Reset GPath Assessment, Request for GPath Questions, How to take GPath, etc</small>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationemail_subject">{{cvEmailSubjectLabel}}</label>
                  <input
                    v-model="vmAdminEmailTempFormData.email_subject"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationemail_body">{{cvEmailBodyLabel}}</label>
                  <vue-editor v-model="vmAdminEmailTempFormData.email_body"></vue-editor>
                </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                  <b-spinner label="Spinning"></b-spinner>
                </button>
                <button type="button" class="btn btn-primary mr-1" @click="showadminEmailTemplateViewDialog(vmAdminEmailTempFormData)" size="sm">View Email Template </button>
                <button type="button" class="btn btn-primary" @click="adminEmailTemplateEdit()">{{cvSubmitBtn}}</button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>

    <b-modal
      v-model="showModeladminEmailTemplateView"
      scrollable
      :title="cvViewModalHeader"
      size="xxl"
    >
      <adminEmailTemplateView :propOpenedInModal="true" :propAdminEmailTempObj="adminEmailTemplateViewObj" @emitCloseadminEmailTemplateViewModal="closeadminEmailTemplateViewModal" />

      <template #modal-footer="">
        <b-button size="sm" @click="closeadminEmailTemplateViewModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { AdminEmailTemplateApiObj } from "../../../FackApi/api/AdminEmailTemplate.js"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission.js"
import { VueEditor } from "vue2-editor"
import adminEmailTemplateView from "./AdminEmailTemplateView.vue"

export default {
  name: "adminEmailTemplateEdit",
  components: {
    VueEditor,
    adminEmailTemplateView
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propAdminEmailTempObj: {
      type: Object,
      default: function () {
        return {
          "email_template_id": "",
          "email_template_name": "",
          "module_object_id": "",
          "module_name": "",
          "app_domain": "",
          "email_subject": "",
          "email_body": ""
        }
      }
    }
  },
  data () {
    return {
      cvCardTitle: "Edit Email Template",
      cvSubmitBtn: "Save",
      cvDomainName: "For which domain are your configuring the email template ?",
      cvAIActions: "Add action keyword for AI to understand the context",
      cvEmailTemplateIdLabel: "Email Template Id",
      cvEmailTemplateNameLabel: "Email Template Name",
      cvModuleObjectIdLabel: "Module Object Id",
      cvModuleNameLabel: "Module Name",
      cvEmailSubjectLabel: "Email Subject",
      cvEmailBodyLabel: "Email Body",
      cvViewModalHeader: "View Email Template",
      adminEmailTemplateViewObj: null,
      showToast: false,
      cvLoadingStatus: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Email Template Updated",
      vmAdminEmailTempFormData: {},
      showModeladminEmailTemplateView: false,
      cvbtnModalCancel: "Cancel",
      email_template_id_copy: ""
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    await this.adminEmailTemplateView()
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmAdminEmailTempFormData) {
          if (!this.vmAdminEmailTempFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * adminEmailTemplateView
     */
    async adminEmailTemplateView () {
      try {
        if (this.propOpenedInModal) {
          this.vmAdminEmailTempFormData = this.propAdminEmailTempObj
          this.vmAdminEmailTempFormData.app_email_domain = this.propAdminEmailTempObj.app_domain
          this.vmAdminEmailTempFormData.email_template_id_copy = this.propAdminEmailTempObj.email_template_id
        }
        else {
          let adminemailtempId = this.propAdminEmailTempObj.email_template_id
          let adminEmailTemplateViewResp = await AdminEmailTemplateApiObj.adminEmailTemplateView(this, adminemailtempId)

          if (adminEmailTemplateViewResp && adminEmailTemplateViewResp.resp_status) {
            this.vmAdminEmailTempFormData = adminEmailTemplateViewResp.resp_data.data
            this.vmAdminEmailTempFormData.app_email_domain = adminEmailTemplateViewResp.resp_data.data.app_domain
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at adminEmailTemplateView() and Exception:", err.message)
      }
    },
    /**
     * adminEmailTemplateEdit
     */
    async adminEmailTemplateEdit () {
      try {
        // if (!this.validate()) {
        //   return false
        // }
        this.cvLoadingStatus = true
        let history = []

        try {
          history = JSON.parse(this.vmAdminEmailTempFormData.history) || []
          if (!Array.isArray(history)) history = []
        }
        catch {
          history = []
        }

        history.push({
          user_id: this.userData.user_id,
          modified_on: new Date().toISOString()
        })

        this.vmAdminEmailTempFormData.history = JSON.stringify(history)

        this.propAdminEmailTempObj.user_id = null

        let adminEmailTemplateAddResp = await AdminEmailTemplateApiObj.adminEmailTemplateEdit(this, this.vmAdminEmailTempFormData)
        await ApiResponse.responseMessageDisplay(this, adminEmailTemplateAddResp)

        if (adminEmailTemplateAddResp && !adminEmailTemplateAddResp.resp_status) {
          return false
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseadminEmailTemplateEditModal", this.vmAdminEmailTempFormData)
        }
      }
      catch (err) {
        console.error("Exception occurred at adminEmailTemplateEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * showadminEmailTemplateViewDialog
     */
    showadminEmailTemplateViewDialog (item) {
      try {
        this.adminEmailTemplateViewObj = item
        this.showModeladminEmailTemplateView = true
      }
      catch (err) {
        console.error("Exception occurred at showadminEmailTemplateDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * closeadminEmailTemplateEditModal
     */
    closeadminEmailTemplateViewModal () {
      try {
        this.showModeladminEmailTemplateView = false
      }
      catch (err) {
        console.error("Exception occurred at closeadminEmailTemplateViewModal() and Exception:", err.message)
      }
    }
  }
}
</script>
